import { render, staticRenderFns } from "./CompleteSignup.vue?vue&type=template&id=5620cd7d&"
import script from "./CompleteSignup.vue?vue&type=script&lang=js&"
export * from "./CompleteSignup.vue?vue&type=script&lang=js&"
import style0 from "./CompleteSignup.vue?vue&type=style&index=0&id=5620cd7d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports